<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content">
    <lcl-real-list config-module="225100" />
  </div>
</template>

<script>
import LclRealList from '@/views/cargo/v0/Price/components/list/lclRealList'

export default {
  name: 'PriceLCLReal',
  components: {
    LclRealList
  }
}
</script>

<style lang="scss">
</style>
